import { useMutation } from "@/compat/reactQuery";
import userAlertSettingService from "../../services/userAlertSettingService";

const useAddUserAlertSetting = () =>
  useMutation(userAlertSettingService.create);

export default useAddUserAlertSetting;
